export enum EcommerceEndpointsEnum {
  PRODUCTS = "class-type",
  // PRODUCT_DETAILS = "class-type/:productId",
  PRODUCT_DETAILS = "products/:productId",
  PRODUCT_DETAILS_A = "products/",
}
